import React from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import WhistleblowerLogin from './pages/WhistleblowerLogin';
import WhistleblowerReturnLogin from './pages/WhistleblowerReturnLogin';
import WhistleblowerForm from './pages/WhistleblowerForm';
import WhistleblowerConfirmation from './pages/WhistleblowerConfirmation';
import WhistleblowerDashboard from './pages/WhistleblowerDashboard';
import PublicRUHForm from './pages/PublicRUHForm';
import CompanyWelcome from './pages/CompanyWelcome';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const WhistleblowerModule = () => {
  return (
    <Routes>
      {/* 
         1. Hvis brukeren går til /whistleblower (uten noe mer), 
         videresend automatisk til /whistleblower/login 
      */}
      <Route index element={<Navigate to="login" replace />} />

      {/* 2. Eksplisitte ruter */}
      <Route path="login" element={<WhistleblowerLogin />} />
      <Route path="return-login" element={<WhistleblowerReturnLogin />} />
      <Route path="skjema/:companyId" element={<WhistleblowerForm />} />
      <Route path="bekreftelse" element={<WhistleblowerConfirmation />} />
      <Route path="status/:id" element={<WhistleblowerDashboard />} />
      <Route path="ruh/:companyId" element={<PublicRUHForm />} />
      <Route path="velkommen/:companyId" element={<CompanyWelcome />} />

      {/* 3. Fallback for ukjente under-ruter */}
      <Route path="*" element={
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="text-center bg-white p-8 rounded-xl shadow-sm border border-gray-200">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiIcons.FiAlertCircle} className="text-gray-400 text-3xl" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Side ikke funnet</h2>
            <p className="text-gray-600 mb-6">Vi fant ikke siden du lette etter i varslermodulen.</p>
            <div className="flex flex-col gap-3">
                <Link to="login" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                    Gå til varslingsskjema
                </Link>
                <Link to="/" className="text-gray-500 hover:text-gray-700 text-sm">
                    Tilbake til forsiden
                </Link>
            </div>
          </div>
        </div>
      } />
    </Routes>
  );
};

export default WhistleblowerModule;